import { whenever } from '@vueuse/core';

export default defineNuxtPlugin({
  name: 'kygunco:clarity',
  dependsOn: ['kygunco:bus'],
  parallel: true,
  setup: () => {
    const config = useRuntimeConfig().public.clarity;
    const { $bus } = useNuxtApp();
    const userStore = useUserStore();
    const enabled = config.enabled;

    const { proxy, load, onError } = useScriptClarity({
      scriptOptions: {
        trigger: 'manual',
      },
    });

    const track = (event: string) => proxy.clarity('event', event);

    const tag = (key: string, ...value: (string | string[])[]) => proxy.clarity('set', key, value);

    const upgrade = (reason: string) => proxy.clarity('upgrade', reason);

    const identify = (
      customId: string,
      customSessionId?: string,
      customPageId?: string,
      friendlyName?: string) =>
      proxy.clarity('identify', customId, customSessionId, customPageId, friendlyName);

    /**
     * Since this script is not critical to the site, we'll just catch the exception and do nothing.
     * The API is stubbed, so it will be safe to use but will do nothing without the script.
     */
    onError(noop);

    whenever(
      () => userStore.data,
      data => identify(data.id, undefined, undefined, data.id),
    );

    $bus.once('app:interacted', () => enabled && load());

    $bus.on('checkout:start', () => {
      upgrade('Started checkout');
      track('Start checkout');
    });

    $bus.on('checkout:cancel', () => track('Cancel checkout'));
    $bus.on('checkout:complete', () => track('Complete checkout'));

    $bus.on('credova:checkout:start', () => track('Start Credova checkout'));
    $bus.on('credova:checkout:cancel', () => track('Cancel Credova checkout'));
    $bus.on('credova:checkout:complete', () => track('Complete Credova checkout'));

    return {
      provide: {
        clarity: {
          enabled,
          upgrade,
          identify,
          tag,
          track,
        },
      },
    };
  },
});
